import { RouterProvider } from 'react-router-dom';

import Providers from 'app/providers';
import router from 'app/router';

// ==============================|| APP ||============================== //
//
// The whole app: the provider stack (src/app/providers.tsx) around the router
// (src/app/router.tsx, which composes each feature's own routes.tsx).

export default function App() {
  return (
    <Providers>
      <RouterProvider router={router} />
    </Providers>
  );
}
